import withMetadataArgument from '../min/exports/withMetadataArgument.js'

import _getNumberType from '../es6/legacy/getNumberType.js'

export function getNumberType() {
	return withMetadataArgument(_getNumberType, arguments)
}



//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/index.es6.exports/getNumberType.js
// module id = 1146
// module chunks = 22